import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Modal from "./Modal";

const banner = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "10px 18px",
  width: "100%",
  padding: "24px 52px 16px",
  background: "#ffffff",
  borderBottom: "1px solid #ebedf0",
  boxShadow: "0 2px 8px rgba(16, 24, 40, 0.06)",
  color: "#2b3543",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "14.5px",
  lineHeight: 1.45,
  textAlign: "center",
  zIndex: 1,
};

const message = {
  display: "inline-flex",
  alignItems: "center",
  gap: "9px",
};

const infoIcon = {
  color: "#aa288c",
  fontSize: "15px",
  flex: "none",
};

const siteLink = {
  color: "#007bff",
  fontWeight: 600,
  textDecoration: "none",
};

const readMore = {
  background: "none",
  border: "1px solid #d8a9cc",
  borderRadius: "16px",
  padding: "3px 14px",
  color: "#aa288c",
  fontFamily: "inherit",
  fontSize: "13px",
  fontWeight: 600,
  cursor: "pointer",
  whiteSpace: "nowrap",
};

const close = {
  position: "absolute",
  top: "50%",
  right: "16px",
  transform: "translateY(-50%)",
  background: "none",
  border: "none",
  color: "#9aa3ad",
  fontSize: "22px",
  lineHeight: 1,
  cursor: "pointer",
  padding: "2px 6px",
};

function RetiredBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [showMore, setShowMore] = useState(false);

  function dismiss() {
    setDismissed(true);
  }

  if (dismissed) {
    return null;
  }

  return (
    <React.Fragment>
      <div style={banner} role="status">
        <span style={message}>
          <FontAwesomeIcon icon={faInfoCircle} style={infoIcon} />
          <span>
            This website has been retired. My portfolio is now at{" "}
            <a href="https://aahil.dev" style={siteLink}>
              aahil.dev
            </a>
            .
          </span>
        </span>
        <button type="button" style={readMore} onClick={() => setShowMore(true)}>
          Read more
        </button>
        <button type="button" style={close} aria-label="Dismiss notice" onClick={dismiss}>
          &times;
        </button>
      </div>

      {showMore ? (
        <Modal title="Site Retired" toggle={() => setShowMore(false)} height="260px">
          <p
            style={{
              fontSize: "15px",
              lineHeight: 1.65,
              color: "#33425b",
              padding: "0 6px",
              textAlign: "left",
              margin: "8px 0 22px",
            }}
          >
            I built this site during college to support my search for internships and
            full-time roles, and it served that purpose well. I have since retired it in favour of my
            new portfolio at{" "}
            <a href="https://aahil.dev" style={siteLink}>
              aahil.dev
            </a>
            .
          </p>
        </Modal>
      ) : null}
    </React.Fragment>
  );
}

export default RetiredBanner;
